<template>
  <div class="content-layout mh2-l">
    <div class="mv2 template-search-layout">
      <search :placeholder="searchPlaceholder" @search="runSearch" @reset="resetSearch"/>
      <template-create @save="onSave"/>
    </div>
    <async-component :params="apiParams" :asyncFunction="loadTemplates" #default="{ loading, error }">
      <div class="flex flex-column items-center w-100">
        <templates-list :loading="loading" :templates="templates" :error="error"/>
        <div class="pv3 flex justify-center bg-ligh" v-if="totalCount > limit">
          <paginator :page="page" :total="pageCount" :routing="false" @goto="switchPage"/>
        </div>
      </div>
    </async-component>
  </div>
</template>

<script>
import { DataService } from '@/services/DataService.js'
import Search from '@/components/common/Search.vue'
import CreateButton from '@/components/ui/Button.vue'
import TemplateCreate from '@/components/document_templates/Create.vue'
import TemplatesList from '@/components/document_templates/List.vue'
import AsyncComponent from '@/components/AsyncComponent.vue'
import Paginator from '@/components/Paginator.vue'

export default {
  components: {
    Search,
    CreateButton,
    TemplateCreate,
    TemplatesList,
    AsyncComponent,
    Paginator
  },
  data () {
    return {
      templates: [],
      totalCount: 0,
      limit: 20,
      page: 1,
      search: null
    }
  },
  methods: {
    onSave (data) {
      this.loadTemplates(this.apiParams)
    },

    switchPage ({ query: { page } }) {
      this.page = page
    },
    loadTemplates (params) {
      return DataService.getDocumentTemplates(params)
        .then(({ data: { documentTemplates } }) => {
          this.templates = documentTemplates.data
          this.totalCount = documentTemplates.totalCount
        })
    },
    runSearch (pattern) {
      this.search = pattern
    },
    resetSearch () {
      this.search = null
    }
  },
  computed: {
    apiParams () {
      return {
        filter: {
          ...this.search && { search: this.search }
        },
        limit: this.limit,
        offset: (this.page - 1) * this.limit
      }
    },
    pageCount () {
      return this.totalCount % this.limit ? Math.floor(this.totalCount / this.limit) + 1 : this.totalCount / this.limit
    },
    searchPlaceholder () {
      return 'поиск шаблонов документов'
    }
  }
}
</script>

<style lang="scss" scoped>
.content-layout {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
}
.template-search-layout {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto;
  column-gap: .5rem;
}
</style>
